import React from "react";
import FormHelperText from "components/Form/components/FormHelperText";
import PropTypes from "prop-types";
import FormSubtext from "./FormSubtext";

const Textarea = ({
  id,
  classes,
  name,
  label,
  error,
  register,
  ...inputProps
}) => (
  <>
    <label htmlFor={id ?? name}>{label}</label>
    {inputProps.subtext && <FormSubtext text={inputProps.subtext} />}
    <textarea
      defaultValue={inputProps.defaultValue}
      rows={inputProps.rows}
      placeholder={inputProps.placeholder}
      {...register(name)}
      className={`input ${classes ?? ""}`}
      id={id ?? name}
      aria-label={label}
    />
    {error && <FormHelperText message={error.message} />}
  </>
);

Textarea.propTypes = {
  // common
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  register: PropTypes.func.isRequired,
  error: PropTypes.shape({ message: PropTypes.string.isRequired }),

  // specific
  type: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  classes: PropTypes.string,
};

export default Textarea;
